import { Trash2 } from 'lucide-react'
import { toast } from 'sonner'

import { Button } from '@/components/ui/button'
import { ConfirmationDialog } from '@/components/ui/confirmation-dialog'
import { parseError } from '@/lib/errors'
import { type EmailTemplate, useDeleteEmailTemplate } from '@/models/emailTemplate'

interface DeleteTemplateButtonProps {
  template: EmailTemplate
}

export function DeleteTemplateButton({ template }: DeleteTemplateButtonProps) {
  const deleteMutation = useDeleteEmailTemplate()

  async function handleDelete() {
    try {
      await deleteMutation.mutateAsync(template.id)
    } catch (err) {
      toast.error(parseError(err))
    }
  }

  return (
    <ConfirmationDialog
      title={template.isGlobal ? 'Delete this global template?' : 'Delete this template?'}
      description={
        template.isGlobal ? 'Everyone on the team loses it. This can’t be undone.' : 'This can’t be undone.'
      }
      confirmLabel="Delete"
      onConfirm={handleDelete}
    >
      <Button variant="destructive" disabled={deleteMutation.isPending}>
        <Trash2 />
        Delete
      </Button>
    </ConfirmationDialog>
  )
}
